// Theme: future-dusk
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'future-dusk',
  name: 'FUTURE DUSK',
  tagline: 'FUTURE DUSK',
  description: 'Indigo crepuscular com base limpa e leitura consistente.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#101426', '#1A2040', '#818CF8', '#E0E7FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-future-dusk'
  },
  colorVars: {
    '--accent': '#818CF8',
    '--accent-foreground': '#101426',
    '--background': '#101426',
    '--border': '#3A4070',
    '--card': '#1A2040',
    '--card-border-active': 'rgba(129, 140, 248, 0.35)',
    '--card-completed': '#171C36',
    '--card-foreground': '#E0E7FF',
    '--card-glow': 'rgba(129, 140, 248, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#E0E7FF',
    '--hold-fill': '#818CF8',
    '--input': '#3A4070',
    '--modal-bg': '#101426',
    '--modal-border': '#3A4070',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#3A4070',
    '--muted-foreground': '#E0E7FF',
    '--nav-active': '#818CF8',
    '--nav-bg': '#1A2040',
    '--popover': '#1A2040',
    '--popover-foreground': '#E0E7FF',
    '--primary': '#818CF8',
    '--primary-foreground': '#101426',
    '--ring': '#818CF8',
    '--secondary': '#3A4070',
    '--secondary-foreground': '#E0E7FF',
    '--streak': '#818CF8',
    '--success': '#22c55e',
    '--success-foreground': '#101426',
    '--xp': '#818CF8',
    '--xp-bg': '#1A2040'
  },
  resolvedVars: {
    '--accent': '#818CF8',
    '--accent-foreground': '#101426',
    '--accent-foreground-hsl': '229 41% 11%',
    '--accent-foreground-oklch': 'from #101426 l c h',
    '--accent-hsl': '234 89% 74%',
    '--accent-oklch': 'from #818CF8 l c h',
    '--background': '#101426',
    '--background-hsl': '229 41% 11%',
    '--background-oklch': 'from #101426 l c h',
    '--border': '#3A4070',
    '--border-hsl': '233 32% 33%',
    '--border-oklch': 'from #3A4070 l c h',
    '--border-w': '1px',
    '--card': '#1A2040',
    '--card-border-active': 'rgba(129, 140, 248, 0.35)',
    '--card-completed': '#171C36',
    '--card-completed-hsl': '230 40% 15%',
    '--card-completed-oklch': 'from #171C36 l c h',
    '--card-foreground': '#E0E7FF',
    '--card-foreground-hsl': '226 100% 94%',
    '--card-foreground-oklch': 'from #E0E7FF l c h',
    '--card-glow': 'rgba(129, 140, 248, 0.08)',
    '--card-hsl': '231 42% 18%',
    '--card-oklch': 'from #1A2040 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E0E7FF',
    '--foreground-hsl': '226 100% 94%',
    '--foreground-oklch': 'from #E0E7FF l c h',
    '--hold-fill': '#818CF8',
    '--hold-fill-hsl': '234 89% 74%',
    '--hold-fill-oklch': 'from #818CF8 l c h',
    '--input': '#3A4070',
    '--input-hsl': '233 32% 33%',
    '--input-oklch': 'from #3A4070 l c h',
    '--modal-bg': '#101426',
    '--modal-bg-hsl': '229 41% 11%',
    '--modal-bg-oklch': 'from #101426 l c h',
    '--modal-border': '#3A4070',
    '--modal-border-hsl': '233 32% 33%',
    '--modal-border-oklch': 'from #3A4070 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#3A4070',
    '--muted-foreground': '#E0E7FF',
    '--muted-foreground-hsl': '226 100% 94%',
    '--muted-foreground-oklch': 'from #E0E7FF l c h',
    '--muted-hsl': '233 32% 33%',
    '--muted-oklch': 'from #3A4070 l c h',
    '--nav-active': '#818CF8',
    '--nav-active-hsl': '234 89% 74%',
    '--nav-active-oklch': 'from #818CF8 l c h',
    '--nav-bg': '#1A2040',
    '--nav-bg-hsl': '231 42% 18%',
    '--nav-bg-oklch': 'from #1A2040 l c h',
    '--popover': '#1A2040',
    '--popover-foreground': '#E0E7FF',
    '--popover-foreground-hsl': '226 100% 94%',
    '--popover-foreground-oklch': 'from #E0E7FF l c h',
    '--popover-hsl': '231 42% 18%',
    '--popover-oklch': 'from #1A2040 l c h',
    '--primary': '#818CF8',
    '--primary-foreground': '#101426',
    '--primary-foreground-hsl': '229 41% 11%',
    '--primary-foreground-oklch': 'from #101426 l c h',
    '--primary-hsl': '234 89% 74%',
    '--primary-oklch': 'from #818CF8 l c h',
    '--radius': '8px',
    '--ring': '#818CF8',
    '--ring-hsl': '234 89% 74%',
    '--ring-oklch': 'from #818CF8 l c h',
    '--secondary': '#3A4070',
    '--secondary-foreground': '#E0E7FF',
    '--secondary-foreground-hsl': '226 100% 94%',
    '--secondary-foreground-oklch': 'from #E0E7FF l c h',
    '--secondary-hsl': '233 32% 33%',
    '--secondary-oklch': 'from #3A4070 l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#818CF8',
    '--streak-hsl': '234 89% 74%',
    '--streak-oklch': 'from #818CF8 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#101426',
    '--success-foreground-hsl': '229 41% 11%',
    '--success-foreground-oklch': 'from #101426 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(234 89% 74% / 0.15)',
    '--xp': '#818CF8',
    '--xp-bg': '#1A2040',
    '--xp-bg-hsl': '231 42% 18%',
    '--xp-bg-oklch': 'from #1A2040 l c h',
    '--xp-hsl': '234 89% 74%',
    '--xp-oklch': 'from #818CF8 l c h'
  }
}
